export default "__VITE_ASSET__DEsurg0b__"